import { AxiosInstance } from 'axios';
import { IElectionResult } from '../models/election-result';
import { IPublishStatus } from '../models/election-result/publish-status';
import { IIrvResultRound } from '../models/irv-result-round';
import { IIrvResultScore } from '../models/irv-result-score';
import { ISumResultScore } from '../models/sum-result-score';

export interface ResultCalculationOptions {

    privateKey?: string;
}

export type ResultExportFileFormat = 'Pdf' | 'Xlsx';

export class ElectionResultClient {

    constructor(private axiosClient: AxiosInstance, private baseUrl: string) {

    }

    public get apiUrl() {
        return `/electionResult`;
    }

    public async getSumResult(electionId: string, options?: ResultCalculationOptions): Promise<IElectionResult<ISumResultScore>> {

        const response = await this.axiosClient.post(
            `${this.apiUrl}/${electionId}/sum`,
            options
        );

        return response.data;
    }

    public async publishSumResult(electionId: string): Promise<IPublishStatus> {

        const response = await this.axiosClient.post(
            `${this.apiUrl}/${electionId}/sum/publish`
        );

        return response.data;
    }

    public async getIrvResult(electionId: string, options?: ResultCalculationOptions): Promise<IElectionResult<IIrvResultScore>> {

        const response = await this.axiosClient.post(
            `${this.apiUrl}/${electionId}/irv`,
            options
        );

        return response.data;
    }

    public async publishIrvResult(electionId: string): Promise<IPublishStatus> {

        const response = await this.axiosClient.post(
            `${this.apiUrl}/${electionId}/irv/publish`
        );

        return response.data;
    }

    public async getIrvPositionRoundsResult(electionId: string, positionId: string): Promise<IIrvResultRound[]> {

        const response = await this.axiosClient.get(`${this.apiUrl}/${electionId}/irv/${positionId}/rounds`);

        return response.data;
    }

    public getExportSumResultLink(electionId: string, format: ResultExportFileFormat): string {

        return `${this.baseUrl}${this.apiUrl}/${electionId}/sum/export?fileFormat=${format}`;
    }

    public getExportIrvResultLink(electionId: string, format: ResultExportFileFormat): string {

        return `${this.baseUrl}${this.apiUrl}/${electionId}/irv/export?fileFormat=${format}`;
    }
}
